import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ParamMapService {
    public getParam(route: ActivatedRoute, param: string): string {
        const numberOfLevelsToSearch = 6;
        var level = route;

        for (var i = 0; i < numberOfLevelsToSearch; i++) {
            if (level) {
                if (level.snapshot.params[param])
                    return level.snapshot.params[param];
            }
            level = level.parent;
        }
    }
}